<mat-form-field appearance="outline" class="mb-3 w-100">
  <mat-label>Поиск</mat-label>
  <input
    type="text"
    matInput
    [placeholder]="label"
    [disabled]="isDisabled"
    [matAutocomplete]="auto"
    [formControl]="materialsControl"
    #input
    (focusin)="inputInFocus()" />
  <mat-hint> {{ helperText }}</mat-hint>

  <mat-autocomplete
    #auto="matAutocomplete"
    [class]="UIThemeService.purpleDarkThemeFieldPanel() | async">
    <ng-container *ngIf="materials$">
      <mat-option
        *ngFor="let option of materials$"
        [value]="option.title"
        (click)="select(option.id)">
        <p>
          <span [ngStyle]="{ color: option.group.color }">
            {{ option.group.full_name }}
          </span>
          : {{ option.title }}
        </p>
      </mat-option>
      <mat-option
        disabled
        *ngIf="!loading$ && materials$ && materials$.length === 0">
        Нет совпадений
      </mat-option>
    </ng-container>

    <ng-container *ngIf="data">
      <ng-container [ngSwitch]="isEmptyData()">
        <ng-container *ngSwitchDefault>
          <mat-option disabled>Совпадений нет</mat-option>
        </ng-container>

        <ng-container *ngSwitchCase="false">
          <mat-option
            *ngFor="let option of data"
            [value]="option.name"
            (click)="select(option.id)">
            <p>
              <strong>{{ option.name }}</strong>
            </p>
          </mat-option>
        </ng-container>
      </ng-container>
    </ng-container>

    <mat-option disabled *ngIf="loading$" class="is-loading">
      <app-loader></app-loader>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
